import { render } from "./SmsMessages.vue?vue&type=template&id=7a314dc2&scoped=true"
import script from "./SmsMessages.vue?vue&type=script&lang=js"
export * from "./SmsMessages.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a314dc2"]])

export default __exports__